// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data_wrap[data-v-544c76a1]{display:flex;flex-direction:column;height:100%}", ""]);
// Exports
module.exports = exports;
